<template>
  <v-container
    v-if="item.video || item.video_youtube"
    class="py-10 py-md-13 py-lg-16"
  >
    <TitleWidget :title="title" :subtitle="subtitle" />

    <div class="mt-6 mt-md-8">
      <video
        v-if="item.video"
        class="video"
        :src="files + item.video"
        nocontrols
        autoplay
        loop
        muted
      ></video>

      <div v-else-if="item.video_youtube" class="video-youtube">
        <iframe
          :src="`https://www.youtube.com/embed/${getYoutubeCode(
            item.video_youtube
          )}`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import { getYoutubeCode } from "../../utils/getYoutubeCode";

const _config = {
  mod: "about",
};

const _data = {
  title: "Mais Sobre",
  subtitle: "TCHAU GOTEIRA",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    getYoutubeCode,
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.video {
  display: block;
  width: 100%;
}

.video-youtube::v-deep {
  aspect-ratio: 16 / 9;
  -o-object-fit: contain;
  object-fit: contain;
  display: block;
  width: 100%;

  iframe {
    display: block;
    height: 100% !important;
    width: 100% !important;
  }
}
</style>
